module.exports = __webpack_public_path__ + "static/media/Learn Icon ΓÇô 1.86664539.png";